import * as Network$dJsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic$dPromotions$dFirstOrderDiscount$dRPC$dTypes from "../Restaumatic.Promotions.FirstOrderDiscount.RPC.Types/index.js";
import * as Restaumatic$dSite$dRPC from "../Restaumatic.Site.RPC/index.js";
const fodBackend = {
  claimFOD: /* #__PURE__ */ Restaumatic$dSite$dRPC.sitesRPC(/* #__PURE__ */ Network$dJsonRPC.encodeRequest(Restaumatic$dPromotions$dFirstOrderDiscount$dRPC$dTypes.encodeClaimFODRequest)({
    encodeWithOptions: v => Restaumatic$dPromotions$dFirstOrderDiscount$dRPC$dTypes.encodeClaimFODRequest.encode
  }))(/* #__PURE__ */ Network$dJsonRPC.decodeResponse(Restaumatic$dPromotions$dFirstOrderDiscount$dRPC$dTypes.decodeClaimFODResponse))(Restaumatic$dPromotions$dFirstOrderDiscount$dRPC$dTypes.rpcMethodNameClaimFODRequest)
};
export {fodBackend};
